module.exports = __webpack_public_path__ + "img/p1only.a27931a7.png";